import { render, staticRenderFns } from "./ViewerHeaderBasicSkChemical.vue?vue&type=template&id=55d4cd79"
import script from "./ViewerHeaderBasicSkChemical.vue?vue&type=script&lang=js"
export * from "./ViewerHeaderBasicSkChemical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports